import { createSelector } from '@ngrx/store';
import { flowStatusFeature } from './flow-status-feature';

export const selectFlowStatus = (id: string) => createSelector(
  flowStatusFeature.selectEntities,
  entities => entities[id],
);
